import Logo from "./Logo";
import { BRAND, CONTACT, scrollToId } from "../data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-gold-faint bg-night pb-10 pt-14 text-cream">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-8 px-5 text-center sm:px-8">
        <Logo className="h-12 w-12" dark />
        <div>
          <p className="font-serif text-2xl tracking-[0.08em]">VAYU CELEBRATIONS</p>
          <p className="mt-1 text-[10px] uppercase tracking-[0.4em] text-gold">{BRAND.tagline}</p>
        </div>
        <nav className="flex flex-wrap justify-center gap-6 text-[11px] uppercase tracking-[0.25em] text-cream/60">
          <button data-testid="footer-about-link" onClick={() => scrollToId("about")} className="transition-colors hover:text-gold">About</button>
          <button data-testid="footer-services-link" onClick={() => scrollToId("services")} className="transition-colors hover:text-gold">Services</button>
          <button data-testid="footer-contact-link" onClick={() => scrollToId("contact")} className="transition-colors hover:text-gold">Contact</button>
        </nav>
        <p className="font-script text-2xl text-gold">{BRAND.motto}</p>
        <p className="text-xs text-cream/40">
          © {new Date().getFullYear()} {BRAND.name} · {CONTACT.address}
        </p>
      </div>
    </footer>
  );
}
